import { cn } from "@/utils/cn";
import { memo } from "react";

interface MoreIconProps {
  className?: string;
}

export const MoreIcon = memo(function MoreIcon({ className }: MoreIconProps) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path d="M13 11.5C13 11.7967 12.912 12.0867 12.7472 12.3334C12.5824 12.58 12.3481 12.7723 12.074 12.8858C11.7999 12.9994 11.4983 13.0291 11.2074 12.9712C10.9164 12.9133 10.6491 12.7704 10.4393 12.5607C10.2296 12.3509 10.0867 12.0836 10.0288 11.7926C9.97094 11.5017 10.0006 11.2001 10.1142 10.926C10.2277 10.6519 10.42 10.4176 10.6666 10.2528C10.9133 10.088 11.2033 10 11.5 10C11.8978 10 12.2794 10.158 12.5607 10.4393C12.842 10.7206 13 11.1022 13 11.5ZM5.5 10C5.20333 10 4.91332 10.088 4.66665 10.2528C4.41997 10.4176 4.22771 10.6519 4.11418 10.926C4.00065 11.2001 3.97094 11.5017 4.02882 11.7927C4.0867 12.0836 4.22956 12.3509 4.43934 12.5607C4.64912 12.7705 4.91639 12.9133 5.20737 12.9712C5.49834 13.0291 5.79994 12.9994 6.07403 12.8859C6.34811 12.7723 6.58238 12.5801 6.74721 12.3334C6.91203 12.0867 7 11.7967 7 11.5C7 11.1022 6.84197 10.7207 6.56066 10.4394C6.27936 10.1581 5.89783 10 5.5 10ZM17.5 10C17.2033 10 16.9133 10.088 16.6666 10.2528C16.42 10.4176 16.2277 10.6519 16.1142 10.926C16.0006 11.2001 15.9709 11.5017 16.0288 11.7927C16.0867 12.0836 16.2296 12.3509 16.4393 12.5607C16.6491 12.7705 16.9164 12.9133 17.2074 12.9712C17.4983 13.0291 17.7999 12.9994 18.074 12.8859C18.3481 12.7723 18.5824 12.5801 18.7472 12.3334C18.912 12.0867 19 11.7967 19 11.5C19 11.1022 18.842 10.7207 18.5607 10.4394C18.2794 10.1581 17.8978 10 17.5 10Z" fill="black"/>
    </svg>
  );
});
